import React, { Fragment, memo } from 'react';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';

import RowActions from 'components/RowActions';
import { rowActions as TEXT } from 'locales/en/client';
import DeleteClient from './buttons/DeleteClient';

const ClientActions = ({ client, isOpen, onClickOpen, onClose, position }) => {
  const renderItems = () => {
    const className =
      'block w-full text-left bg-white py-2 px-5 text-xs text-javelin-gray-dark hover:bg-javelin-babyBlue cursor-pointer';
    const viewItem = (
      <Link to={`/clients/${client.id}`} className={className}>
        {TEXT.view}
      </Link>
    );
    const editItem = <span className={className}>Edit</span>;
    const deleteItem = <DeleteClient client={client} className={className} />;
    let options = [viewItem, editItem, deleteItem];

    return options.map((item, idx) => <Fragment key={idx}>{item}</Fragment>);
  };

  return (
    <RowActions
      onClickOpen={onClickOpen}
      isOpen={isOpen}
      onClose={onClose}
      position={position}
    >
      {renderItems()}
    </RowActions>
  );
};

ClientActions.propTypes = {
  onClickOpen: PropTypes.func,
  onClose: PropTypes.func,
  isOpen: PropTypes.bool,
  position: PropTypes.oneOf(['top', 'bottom']),
  id: PropTypes.number,
};
ClientActions.defaultProps = {
  position: 'bottom',
};

export default memo(ClientActions);
